import {useState, useRef, useEffect} from 'react'

export function useGridColumns() {
  const gridRef = useRef(null)
  const [columns, setColumns] = useState(3)

  useEffect(() => {
    if (!gridRef.current) return
    const observer = new ResizeObserver(() => {
      requestAnimationFrame(() => {
        if (!gridRef.current) return
        const cols = window
          .getComputedStyle(gridRef.current)
          .getPropertyValue('grid-template-columns')
          .split(' ').length
        setColumns(cols)
      })
    })
    observer.observe(gridRef.current)
    return () => observer.disconnect()
  }, [])

  return {gridRef, columns}
}
